const wait = (ms) => new Promise((r) => setTimeout(r, ms));
if (typeof document !== "undefined")
  document.addEventListener(
    "click",
    (e) => {
      const el = e.target?.closest?.('button,a,[role="button"]');
      if (!el) return;
      try {
        const rows = JSON.parse(
          sessionStorage.getItem("pisto-action-trail") || "[]",
        );
        rows.push({
          at: new Date().toISOString(),
          path: location.pathname,
          label: String(
            el.getAttribute("aria-label") || el.title || el.textContent || "",
          )
            .trim()
            .slice(0, 120),
        });
        sessionStorage.setItem(
          "pisto-action-trail",
          JSON.stringify(rows.slice(-20)),
        );
      } catch {}
    },
    true,
  );
function diagnostic(entry) {
  try {
    const rows = JSON.parse(
        localStorage.getItem("pisto-pending-diagnostics") || "[]",
      ),
      actions = JSON.parse(
        sessionStorage.getItem("pisto-action-trail") || "[]",
      );
    rows.push({
      ...entry,
      actions,
      build: "1.18.0",
      path: location.pathname,
      userAgent: navigator.userAgent,
      at: new Date().toISOString(),
    });
    localStorage.setItem(
      "pisto-pending-diagnostics",
      JSON.stringify(rows.slice(-30)),
    );
  } catch {}
}
async function flush() {
  try {
    const rows = JSON.parse(
      localStorage.getItem("pisto-pending-diagnostics") || "[]",
    );
    if (!rows.length) return;
    for (const row of rows)
      await fetch("/api/client-errors", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          path: row.path,
          message: `API ${row.status || "network"}: ${row.endpoint}`,
          stack: JSON.stringify(row, null, 2),
        }),
      });
    localStorage.removeItem("pisto-pending-diagnostics");
  } catch {}
}
export async function api(path, options = {}) {
  const opts = { credentials: "include", ...options };
  if (
    opts.body &&
    !(opts.body instanceof FormData) &&
    typeof opts.body !== "string"
  ) {
    opts.headers = {
      ...(opts.headers || {}),
      "Content-Type": "application/json",
    };
    opts.body = JSON.stringify(opts.body);
  }
  const safe = !opts.method || String(opts.method).toUpperCase() === "GET";
  let r;
  for (let attempt = 0; attempt < (safe ? 2 : 1); attempt++) {
    try {
      r = await fetch("/api" + path, opts);
      if (r.status === 503 && safe && attempt === 0) {
        diagnostic({ endpoint: path, status: 503, kind: "host-unavailable" });
        await wait(650);
        continue;
      }
      break;
    } catch (e) {
      diagnostic({ endpoint: path, kind: "network", message: e.message });
      if (safe && attempt === 0) {
        await wait(650);
        continue;
      }
      throw new Error(
        "Could not reach Pisto. Your diagnostic was saved locally.",
      );
    }
  }
  const text = await r.text(),
    html = /^\s*<!doctype html|^\s*<html/i.test(text);
  let data = {};
  if (text && !html) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { error: text.slice(0, 300) };
    }
  }
  if (!r.ok) {
    diagnostic({
      endpoint: path,
      status: r.status,
      kind: html ? "host-html" : "api",
      summary: html
        ? "Host returned an HTML service page"
        : String(data.error || "").slice(0, 300),
    });
    const error=new Error(r.status === 503 || html ? "Pisto server is temporarily unavailable. Please try again shortly." : data.error || `Request failed (${r.status})`);
    Object.assign(error,data,{status:r.status});
    throw error;
  }
  flush();
  return data;
}
export const downloadDiagnostics = () => {
  const text = localStorage.getItem("pisto-pending-diagnostics") || "[]",
    blob = new Blob([text], { type: "application/json" }),
    url = URL.createObjectURL(blob),
    a = document.createElement("a");
  a.href = url;
  a.download = `pisto-diagnostics-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
export const money = (v, c = "EUR") => {
  try {
    if (
      typeof window !== "undefined" &&
      localStorage?.getItem("pisto-hide-values-runtime") === "1"
    )
      return "****.**";
    const code = String(c || "EUR").toUpperCase();
    if (localStorage?.getItem("pisto-currency-display-mode") === "code")
      return `${code} ${new Intl.NumberFormat(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(Number(v || 0))}`;
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      maximumFractionDigits: 2,
    }).format(Number(v || 0));
  } catch {
    return `${Number(v || 0).toFixed(2)} ${c || ""}`.trim();
  }
};
export const dateFmt = (v) => {
  if (!v) return "—";
  const raw = String(v).slice(0, 10),
    d = new Date(`${raw}T12:00:00`);
  if (Number.isNaN(d.getTime())) return raw || "—";
  try {
    return new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(
      d,
    );
  } catch {
    return raw;
  }
};
